import { render, staticRenderFns } from "./95.vue?vue&type=template&id=18308ba1&scoped=true&"
var script = {}
import style0 from "./95.vue?vue&type=style&index=0&id=18308ba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18308ba1",
  null
  
)

export default component.exports